import { scope_perspective_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateScopePerspectiveEnum = (enumValue: scope_perspective_enum) => {
  switch (enumValue) {
    case scope_perspective_enum.OC_LANDLORD:
      return <Trans i18nKey="Enum_ScopePerspectiveEnum-OC_LANDLORD" />;
    case scope_perspective_enum.OC_TENANT:
      return <Trans i18nKey="Enum_ScopePerspectiveEnum-OC_TENANT" />;
    case scope_perspective_enum.WHOLE_BUILDING:
      return <Trans i18nKey="Enum_ScopePerspectiveEnum-WHOLE_BUILDING" />;
  }
};

export const translateScopePerspectiveEnum_dynamic = (enumValue: scope_perspective_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case scope_perspective_enum.OC_LANDLORD:
      return t('Enum_ScopePerspectiveEnum-OC_LANDLORD');
    case scope_perspective_enum.OC_TENANT:
      return t('Enum_ScopePerspectiveEnum-OC_TENANT');
    case scope_perspective_enum.WHOLE_BUILDING:
      return t('Enum_ScopePerspectiveEnum-WHOLE_BUILDING');
  }
};
